import { Injectable, Output, EventEmitter } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ServerConn } from '../serverConn.service';

@Injectable({
    providedIn: 'root'
})
export class HistLactacionesService {

    data: any[] = [];
    length = 0;
    lact: any[] = [];
    @Output()
    needUpdate: EventEmitter<any> = new EventEmitter();
    selectedCEA = '';

    constructor(private server: ServerConn) { }

    setCEA(cea) {
        this.selectedCEA = cea;
        this.needUpdate.emit(cea);
    }

    get(): Observable<any> {
        if (!this.data.length) {
            /**
             * Retornamos un
             */
            return Observable.create(observer => {
                this.server.get(
                    'reports/hist-lactaciones',
                    {
                        a: 'g'
                    }
                ).subscribe(
                    (res: any) => {
                        const data = (typeof res.json !== 'undefined') ? res.json() : res;
                        this.data = data;
                        observer.next(res);
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        } else {
            return of(this.data);
        }
    }

    getById(id): Observable<any> {
        /**
         * Retornamos un
         */
        return Observable.create(observer => {
            this.server.get(
                'reports/hist-lactaciones/' + id
            ).subscribe(
                (res: any) => {
                    const data = (typeof res.json !== 'undefined') ? res.json() : res;
                    this.data = data;
                    console.log(data);
                    observer.next(res);
                }, // simply passing success response
                err => { // error handling
                        observer.error(err); // passing error to the method which invoked request
                },
                () => observer.complete // passing onComplete event);
            );
        });
            // return data;
    }

    getCSV(filter: any, sort: string): Observable<any> {
        // if (!this.data.length) {
            /**
             * Retornamos los animales paginados, ordenados y filtrados desde el servidor
             */
            console.log(filter, JSON.stringify(filter), sort);
            if (this.server.user.level >= 7 && this.selectedCEA > '') {
                filter.cea = {
                    field: 'cea',
                    operation: '=',
                    value: this.selectedCEA
                };
            }
            return Observable.create(observer => {
                this.server.download(
                    'reports/hist-lactaciones',
                    {
                        a: 'gcsv',
                        tblfilter: JSON.stringify(filter),
                        tblorder: sort
                    }
                ).subscribe(
                    (res: any) => {
                        console.log(res);
                        const keys = res.headers.keys();
                        const headers = keys.map(key =>
                            `${key}: ${res.headers.get(key)}`);
                        console.log(headers);

                        const blob = new Blob([res.body], { type: 'text/csv' });
                        const filename = res.headers.get('File-Name');
                        const element = document.createElement('a');
                        element.href = window.URL.createObjectURL(blob);
                        element.download = filename;
                        document.body.appendChild(element);
                        element.click();
                        // window.open(url);
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        // } else {
        //     return Observable.of(this.data);
        // }
    }

    recalcLact(id, date): Observable<any> {
        /**
         * Retornamos un
         */
        return Observable.create(observer => {
            this.server.get(
                'reports/hist-lactaciones/recalc/' + id + '/' + date
            ).subscribe(
                (res: any) => {
                    const data = (typeof res.json !== 'undefined') ? res.json() : res;
                    this.data = data;
                    console.log(data);
                    observer.next(res);
                }, // simply passing success response
                err => { // error handling
                        observer.error(err); // passing error to the method which invoked request
                },
                () => observer.complete // passing onComplete event);
            );
        });
            // return data;
    }

    getCEA(cea): Observable<any> {
        // if (!this.data.length) {
            /**
             * Retornamos todos los animales de la db
             */
            return Observable.create(observer => {
                this.server.get(
                    'reports/hist-lactaciones',
                    {
                        a: 'g',
                        tblfilter: JSON.stringify([
                            {
                                value: cea,
                                operation: '=',
                                field: 'cea'
                            }
                        ])
                    }
                ).subscribe(
                    (res: any) => {
                        const resp = (typeof res.json !== 'undefined') ? res.json() : res;
                        this.data = resp.data;
                        this.length = resp.length;
                        console.log(resp);
                        observer.next(res);
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        // } else {
        //     return Observable.of(this.data);
        // }
    }

    getPending(filter: any, sort: string, start: number, limit: number): Observable<any> {
        // if (!this.data.length) {
            /**
             * Retornamos un
             */
            // console.log(filter, JSON.stringify(filter), sort, start, limit);
            if (this.server.user.level >= 7 && this.selectedCEA > '') {
                filter.cea = {
                    field: 'cea',
                    operation: '=',
                    value: this.selectedCEA
                };
            }
            return Observable.create(observer => {
                this.server.get(
                    'reports/hist-lactaciones',
                    {
                        a: 'g',
                        tblfilter: JSON.stringify(filter),
                        tblorder: sort,
                        tblstart: start,
                        tbllimit: limit
                    }
                ).subscribe(
                    (res: any) => {
                        const resp = (typeof res.json !== 'undefined') ? res.json() : res;
                        this.data = resp.data;
                        this.length = resp.length;
                        observer.next(res);
                    }, // simply passing success response
                    err => { // error handling
                           observer.error(err); // passing error to the method which invoked request
                    },
                    () => observer.complete // passing onComplete event);
                );
            });
            // return data;
        // } else {
        //     return Observable.of(this.data);
        // }
    }

    getLact(id: number): any {
        return Observable.create(observer => {
            this.server.get(
                'reports/hist-lactaciones/' + id
            ).subscribe(
                (res: any) => {
                    this.lact = (typeof res.json !== 'undefined') ? res.json() : res;
                    observer.next(res);
                }, // simply passing success response
                err => { // error handling
                       observer.error(err); // passing error to the method which invoked request
                },
                () => observer.complete // passing onComplete event);
            );
        });
    }

}
